module.exports = "table{\n    width: 90%;\n    margin: 5% 5%;\n\n}\ncaption{\n    font-size: x-large;\n    font-weight: bold;\n}\n\n"